import { createContext, useContext } from "react";
import { Nav, NavItem, NavLink, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import Icon from "components/Icon/Icon";

const MenuContext = createContext();


const Menu = ({ controller }) => {
  const { menuIndex } = controller;
  if (!menuIndex) {
    return null;
  }
  return (
    <MenuContext.Provider value={ controller }>
      <Nav as="ul" variant="pills" className="flex-column" >
        {Object.entries(menuIndex).map(([code, item]) => {
          const key = `menucategory-${code}`;
          if (item.url) {
            return (<MenuItem key={key} code={code} {...item} />);
          }
          return (<MenuCategory key={key} code={code} {...item} />);
        }
        )}
      </Nav>
    </MenuContext.Provider>
  );
};

const MenuCategory = ({ code, title, items }) => {
  const { activeCheck, activateCategory, deactivateCategory } = useContext(MenuContext);
  const clickHandler = () => {
    if (activeCheck(code)) {
      deactivateCategory(code);
    } else {
      activateCategory(code);
    }
  };
  const open = activeCheck(code, "category");
  return (
    <>
      <NavItem as="li">
        <NavLink as="button" className="link-dark px-0" onClick={clickHandler}>
          <Icon icon="drilldown" rotate={open ? "90" : "0"}>{title}</Icon>
        </NavLink>
      </NavItem>
      <Collapse in={open}>
        <div>
          <Nav as="ul" variant="pills" className="flex-column ms-4 small" >
            {(items != null) && Object.entries(items).map(([itemCode, item]) => {
              return (<MenuItem key={`menuitem-${itemCode}`} code={itemCode} {...item} />);
            })}
          </Nav>
          <hr />
        </div>
      </Collapse>
    </>
  );
};

const MenuItem = ({ code, title, url }) => {
  const { activeCheck, activateItem } = useContext(MenuContext);
  const classes = [];
  classes.push(activeCheck(code, "item") ? "active" : "link-dark");
  return (<NavItem as="li">
    <NavLink as={Link} to={url} className={classes.join(" ")} onClick={() => activateItem(code)}>{title}</NavLink>
  </NavItem>);
};

export default Menu;